import { endpoints } from "../helper/endpoints";
import jwtInterceptor from "../helper/jtwInterceptor";
import { DocumentType } from "../helper/enum/DocumentType";
const FileDownload = require('js-file-download');

export function getDocumentFileName(documentType: DocumentType, quoteId: string | number) {
  switch (documentType) {
    case DocumentType.Quote:
      return `quote-${quoteId}.pdf`;

    case DocumentType.Policy:
      return `quote-${quoteId}-policy-schedule.pdf`;

    case DocumentType.Certificate:
      return `quote-${quoteId}-certificate-of-currency.pdf`;

    case DocumentType.DecisionTree:
      return `quote-${quoteId}-record-of-answers.pdf`;

    default:
      throw new Error("Invalid document type");
  }
}

/**
 * Function to get a document any document using quote Id.
 * @param {any} quoteId - The ID of the quote for which the document is to be retrieved.
 * @param {boolean} getDownload - (Optional) A boolean indicating whether to download the document.
 * @returns {Promise} A Promise that resolves with the document if successful.
 */
export const getDocument = async (quoteId: any, documentType: DocumentType, getDownload?: boolean) => {
  try {
    await jwtInterceptor({
        url: `${endpoints.GET_DOCUMENT_BY_QUOTE_ID}?quoteId=${quoteId}&documentType=${documentType}`,
        method: 'GET',
        responseType: 'blob', // Important to specify the response type as 'blob'.
      }).then((response) => {
        // console.log(`Download document for quote ID ${quoteId}`, response);
        if (getDownload === true) {
          // If getDownload is true, download the document as a PDF.
          const fileName = getDocumentFileName(documentType, quoteId);
          FileDownload(response.data, fileName);
        }
        // Return the Blob containing the document.
        return response.data;
      });
  } catch (error: any) {
    console.log("Error getting document", error);
    throw new Error(error);
  }
};